/* eslint-disable no-unused-vars */
export enum RoutePath {
  ALL = '/*',
  LOGIN = '/',
  NOT_FOUND = '/not-found',
  CREATE = '/create',
  DETAIL = '/detail',
  EDIT = '/edit',
  USER = '/user',
  COMPANY = '/company',
  COMPANY_REGISTRATION = '/company-registration',
  PRODUCT = '/product',
  HISTORY_SCAN = '/history-scan',
  REPORT = '/report',
  CHANGE_PASSWORD = '/change-password',
  COMPANY_REGISTRATION_MANAGEMENT = '/company-registration-management',
  COMPANY_ADMIN = '/company-admins',
  COMPANY_STAFF = '/company-staff',
  STICKER = '/sticker',
  RENEWAL = '/renewal',
  REGISTRATION_PREVIEW = '/preview-registration',
  LICENCE_PREVIEW = '/preview-licence',
  ANALYTIC = '/analytic',
  FORGOT_PASSWORD = '/forgot-password',
  NOT_PERMISSION = '/not-permission',
  SYSTEM_ADMIN = '/system-admin',
  SETTING = '/setting'
}
